module.exports = __webpack_public_path__ + "static/media/ZAMORA-DRYWALL-INC-favicon.7802e57b.png";